import { AxiosPromise } from 'axios';
import { Toaster, axiosInstance, getHeaders, isSpanish } from '@share/utils';
import { Urls } from '@share/constants';
import { isEmpty } from 'lodash';

export const QuotesAPI = {
  get(id: string | null): AxiosPromise<any> {
    return axiosInstance.get(`${Urls.Quotes}/${id}`, { ...getHeaders() });
  },
  markQuotesAsRead(id: string): AxiosPromise<any> {
    return axiosInstance.post(`${Urls.Quotes}/${id}/mark-as-read`, { ...getHeaders() });
  }
};

export enum DownLoadShareType {
  CONDO,
  HOTEL,
  WEEK,
  CAR,
  MULTIPLE_QUOTES,
  /** Appended, never inserted: this is a numeric enum and the values are positional. */
  ACTIVITY,
}

export const HandleDownload = (
    type: DownLoadShareType,
    loading: boolean,
    data: any,
    intl: any,
    onFinish: () => void,
    onComplete: () => void,
    onFailed?: (message: string[] | undefined) => void) => {
  if (!loading) {
    const url = type === DownLoadShareType.ACTIVITY ?
                    Urls.ActivityDownload :
                    type === DownLoadShareType.WEEK ? 
                    Urls.QuotesWeeksDownload : 
                    type === DownLoadShareType.CAR ? 
                        Urls.QuotesCarsDownload : 
                        type === DownLoadShareType.CONDO ? 
                            Urls.QuotesCondosDownload : 
                          type === DownLoadShareType.MULTIPLE_QUOTES ? 
                            Urls.MultipleQuotesDownload : 
                            Urls.QuotesHontelsDownload;
    axiosInstance.post(url, data, { ...getHeaders(), responseType: 'blob' })
      .then((response) => {
        const headerLine = response.headers['content-disposition'];
        let filename;
        if (headerLine) {
          const startFileNameIndex = headerLine.indexOf('"') + 1
          const endFileNameIndex = headerLine.lastIndexOf('"');
          filename = headerLine.substring(startFileNameIndex, endFileNameIndex);
        } else {
          filename = `quote_${new Date().getTime()}_download.pdf`;
        }

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        onFinish();
        onComplete();
        link.click();
      })
      .catch(async (e) => {
       let errorObject = null;
       try {
          const error = e.response?.data;
          const errorBlobText = JSON.parse(await error.text());
          errorObject = JSON.parse(errorBlobText);
        } catch(e) {
          console.error(e);
        }

        const msgCode = errorObject?.code;
        const messages = errorObject?.errors;

        if (msgCode === 'room_error' && onFailed) {
          onFailed(messages?.filter((m: any) => !isEmpty(m.message)).map((m: any) => m.message.substring(0, m.message.indexOf(': It was not possible to obtain'))));
        } else {
          onFinish();
          onComplete();

          if (!!messages?.length) {
            messages.forEach((m: any) => {
              Toaster.error(m?.message);
            });
          } else {
            const msg = errorObject?.reason ? 
                           !isSpanish() ?  `Quote send failed: ${errorObject.reason}` : 
                           `Fallo en el envío de la cita: ${errorObject.reason}` : 
                            intl.formatMessage({ id: 'error.code.generic.general' });
            Toaster.error(msg);
          }
        }

      });
  }
}

export const HandleShare = (
    type: DownLoadShareType,
    loading: boolean,
    data: any,
    intl: any,
    onFinish: () => void,
    onComplete: () => void,
    onFailed: (message: string[] | undefined) => void) => {
  if (!loading) {
    const url = type === DownLoadShareType.ACTIVITY ?
                    Urls.ActivityShare :
                    type === DownLoadShareType.WEEK ? 
                    Urls.QuotesWeeksShare : 
                    type === DownLoadShareType.CAR ? 
                        Urls.QuotesCarsShare : 
                        type === DownLoadShareType.CONDO ? 
                              Urls.QuotesCondosShare : 
                              type === DownLoadShareType.MULTIPLE_QUOTES ? 
                                Urls.MultipleQuotesShare : 
                                Urls.QuotesHotelsShare;
    axiosInstance.post(url, data, { ...getHeaders() })
      .then((response) => {
        onFinish();
        onComplete();

        if (response.data.members?.length) {
          Toaster.success(!isSpanish() ? `Success. Quote shared to: ${response.data.members.map((x:string) => (x))}` :
        `Éxito. Cita compartida a: ${response.data.members.map((x:string) => (x))}`);
        }

        if (response.data.memberFailed?.length) {
          Toaster.error(!isSpanish() ? `Quote failed for: ${response.data.memberFailed.map((x:string) => (x))}` 
          : `Cita fallida para: ${response.data.memberFailed.map((x:string) => (x))}`);
        }
      })
      .catch((e) => {
        const error = e.response?.data;

        let errorObject = null;
        try {
          errorObject = JSON.parse(error);
        } catch(e) {
          console.error(e);
        }

        const msgCode = errorObject?.code;
        const messages = errorObject?.errors;

        if (msgCode === 'room_error' && onFailed) {
          onFailed(messages?.filter((m: any) => !isEmpty(m.message)).map((m: any) => m.message.substring(0, m.message.indexOf(': It was not possible to obtain'))));
        } else {
          onFinish();
          onComplete();

          if (!!messages?.length) {
            messages.forEach((m: any) => {
              Toaster.error(m?.message);
            });
          } else {
            const msg = errorObject?.reason ? 
                            !isSpanish() ? `Quote send failed: ${errorObject.reason}` : `Fallo en el envío de la cita: ${errorObject.reason}` : 
                            intl.formatMessage({ id: 'error.code.generic.general' });
            Toaster.error(msg);
          }
        }
      });
  }
}